import React from 'react';
import { Tooltip, Chip } from '@material-ui/core';

const SubassemblyChip = ({ subassembly }) => {

    return (
        <Tooltip title={subassembly.father?.description} placement='bottom'>
            <Chip
                clickable
                key={subassembly.idproduct_sale_subassembly_ref}
                component='a'
                target='_blank'
                style={{ margin: 8 }}
                label={subassembly.father?.code ?? '?'}
                href={`/bom/recipe/detail?id=${subassembly.idfather}`}
            />
        </Tooltip>
    );
}

export default SubassemblyChip;